import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-arrow-down',
  templateUrl: './icon-arrow-down.component.html',
  styleUrls: ['./icon-arrow-down.component.scss']
})
export class IconArrowDownComponent implements OnInit {
  @Input() color = '#262628';
  @Input() size = 18;

  constructor() { }

  ngOnInit() {
  }

}
